export enum UserType {
    INTERNAL = 'INTERNAL',
    EXTERNAL = 'EXTERNAL',
}

export function getUpperUserType(type: string | undefined): string {
    return type?.toUpperCase() || '';
}
